import Cloud from '../campout/objects/Cloud';

export default class HintItem extends Phaser.Group {
  constructor(game, id, angle, size) {
    super(game);

    this.size = size;

    this.circle = this.game.make.image(0, 0, 'hint_item');
    this.circle.anchor.set(0.5);

    this.item = this.game.make.image(0, 0, 'items', id);
    this.item.anchor.set(0.5);
    const sx = 120 / this.item.width;
    const sy = 120 / this.item.height;
    const sc = Math.min(1, Math.min(sx, sy));
    this.item.scale.set(sc);

    this.circle.addChild(this.item);
    this.addChild(this.circle);

    this.angle = angle;
    this.circle.angle = -angle;

    this.circle.scale.set(0);
  }

  show() {
    this.game.add.tween(this.circle).to({ y: -150 }, 250, Phaser.Easing.Quadratic.Out, true);
    this.game.add
      .tween(this.circle.scale)
      .to({ x: this.size, y: this.size }, 250, Phaser.Easing.Quadratic.Out, true);
  }

  hide() {
    this.game.add.tween(this.circle).to({ y: 0 }, 250, Phaser.Easing.Quadratic.In, true);
    this.game.add
      .tween(this.circle.scale)
      .to({ x: 0, y: 0 }, 250, Phaser.Easing.Quadratic.In, true)
      .onComplete.add(this.destroy, this);
  }

  rotateTo(angle) {
    this.game.add.tween(this).to({ angle: angle }, 250, Phaser.Easing.Quadratic.Out, true);
    this.game.add.tween(this.circle).to({ angle: -angle }, 250, Phaser.Easing.Quadratic.Out, true);
  }

  showNewItem(id) {
    // hide current item
    // this.game.add.tween(this.item.scale).to({ x: 0, y: 0 }, 150, null, true);
    this.item.visible = false;

    // show new item
    this.item2 = this.game.make.image(0, 0, 'items', id);
    this.item2.anchor.set(0.5);
    const sx = 120 / this.item2.width;
    const sy = 120 / this.item2.height;
    const sc = Math.min(1, Math.min(sx, sy));
    this.item2.destScale = sc;
    this.item2.scale.set(sc);
    this.circle.addChild(this.item2);

    // this.game.add.tween(this.item2.scale).to({ x: sc, y: sc }, 150, null, true, 150);

    // show sparkles
    const size = 0.6;
    this.cloud = new Cloud(this.game, 0, 0, size);
    this.circle.addChild(this.cloud);
  }

  update() {
    super.update();
    this.cloud && this.cloud.update();
  }
}
